export const SET_CACHE_DATA = 'SET_CACHE_DATA';
export const GET_CACHE_DATA = 'SET_CACHE_DATA';
export const CLEAR_CACHE_DATA_BY_KEY = 'ClEAR_CACHE_DATA_BY_KEY';
export const ClEAR_CACHE_DATA = 'ClEAR_CACHE_DATA';
export const ClEAR_MODULE_CACHE_DATA = 'ClEAR_MODULE_CACHE_DATA';
